import { render, staticRenderFns } from "./videoManagementForm.vue?vue&type=template&id=4d8852df"
import script from "./videoManagementForm.vue?vue&type=script&lang=js"
export * from "./videoManagementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports